module.exports = __webpack_public_path__ + "img/avtar.9e1b01f6.png";